"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const schema_1 = __importDefault(require("./schema"));
const schema_2 = __importDefault(require("../item/schema"));
const schemaComponents_1 = require("@/schemaComponents");
exports.default = () => {
    return (0, schemaComponents_1.mergeSchema)({ schemaType: "object", properties: [] }, [
        {
            title: "言語コード",
            propertyName: "langId",
            schema: {
                schemaType: "text",
                required: true,
            },
        },
        ...(0, schema_1.default)().properties,
        ...(0, schema_2.default)().properties,
        ...schemaComponents_1.timestampsProperties,
    ]);
};
